import BottomNav from "@/components/BottomNav";
import OfflineBanner from "@/components/OfflineBanner";
import DesktopSidebar from "@/components/DesktopSidebar";

/**
 * Responsive shell:
 * - Mobile / tablet: single-column, max-w-md, bottom nav.
 * - Desktop (lg+, ≥1024px): permanent sidebar on the left + wider container.
 *
 * The right/left decorative "background canvas" fills the desktop empty space
 * without stretching mobile-first UI content.
 */
export default function AppShell({ children, hideNav = false, wide = false }) {
  return (
    <div className="min-h-screen bg-background noise-bg text-foreground">
      <OfflineBanner />

      {/* Decorative background — visible only on lg+ to avoid mobile perf cost */}
      <div
        aria-hidden
        className="hidden lg:block fixed inset-0 pointer-events-none opacity-70"
        style={{
          background:
            "radial-gradient(circle at 90% 15%, rgba(222,187,108,0.10) 0%, transparent 45%), radial-gradient(circle at 15% 90%, rgba(8,71,30,0.10) 0%, transparent 40%)",
        }}
      />

      {!hideNav && <DesktopSidebar />}

      <div className={`lg:pl-64 xl:pl-72 ${hideNav ? "" : "pb-24 lg:pb-6"}`}>
        <div
          className={`px-0 lg:px-6 ${
            wide
              ? "max-w-md mx-auto lg:max-w-6xl lg:mx-0"
              : "max-w-md mx-auto lg:max-w-2xl lg:mx-0"
          }`}
        >
          {children}
        </div>
      </div>

      {!hideNav && <BottomNav />}
    </div>
  );
}
